import React, { useRef } from 'react';
import type { UseFetchData } from './type';
import { debounce } from 'lodash';
import { getOpenApiData } from '@/common/asset-apis/assetModel';

export const useFetchData: UseFetchData = ({ setOptionList, API, field }) => {
  const searchData = (value: any): any => {
    const url = field?.options?.detailApiUrl.replace('${value}', value);
    getOpenApiData(API.FetchAPI, 'get', url).then((res: any) => {
      setOptionList(res?.result?.items || []);
    });
  }

  const setServicesValueDebounced = useRef(debounce(searchData, 800));

  const handleSearch = (value: any) => {
    if (!(value?.length > 0)) {
      return;
    }
    setServicesValueDebounced.current(value);
  }

  return {
    handleSearch,
  };
};
